module.exports = require("@wildboar/x500/src/lib/modules/HierarchicalOperationalBindings/SubordinateToSuperior.ta");